<template>
  <div>
    <section class="mb-5">
      <div class="container text-center">
        <div class="col-lg-10 mx-auto">
          <h2 class="font-size-medium font-weight-bold mb-4">Meus Rascunhos</h2>
        </div>
      </div>
    </section>
    <section>
      <div class="container">
        <div
          v-if="posts.length > 0"
        >
          <PostThumbList
            :posts="posts"
          />
          <div class="mt-3 text-center">
            <Button
              class="btn-outline-color2 btn-lg"
              :loading="loader"
              @click="loadMore"
              v-if="isLoadMoreVisible"
            >
              Carregar mais
            </Button>
          </div>
        </div>
        <div
          class="text-center"
          v-else-if="!loader"
        >
          <p class="text-center">Não foi encontrado nenhum rascunho</p>
          <router-link
            :to="{ name: 'posts.create' }"
            class="btn btn-outline-color2 mt-2"
          >
            Escrever agora
          </router-link>
        </div>
        <div
          class="text-center"
          v-else
        >
          <Loader
            color="color2"
            size="big"
          />
        </div>
      </div>
    </section>
  </div>
</template>

<script>

import PostsService from '@/modules/posts/services/posts-service'

import Button from '@/components/common/Button/Button'
import Loader from '@/components/common/Loader/Loader'
import PostThumbList from '@/components/post/PostThumbList'

export default {
  components: {
    Button,
    Loader,
    PostThumbList
  },
  data () {
    return {
      posts: [],
      isLoadMoreVisible: true,
      loader: false,
      page: 1
    }
  },
  created () {
    this.getPosts()
  },
  methods: {
    async getPosts () {
      this.loader = true
      try {
        const posts = await PostsService.getPosts({ status: 'draft', page: this.page })
        this.posts = [...this.posts, ...posts]
        if (posts <= 0) this.isLoadMoreVisible = false
      } catch (error) {
        error.handleGlobally && error.handleGlobally()
      }
      this.loader = false
    },
    loadMore () {
      this.page++
      this.getPosts()
    }
  }
}
</script>
